export default __webpack_public_path__ + "static/media/logo-light.211bd651.svg";